import styled from 'styled-components';

export const AppleModalContainer = styled.div`
  margin-top: 20px;
  padding: 10px;
`;
